// src/components/StudentDetails.js

import React, { useState } from 'react';
import {
  Typography,
  Button,
  Modal,
  Box,
  Avatar,
  Grid,
} from '@mui/material';
import '../styles/Details.css';

const detailsModalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: 700,
  bgcolor: 'background.paper',
  borderRadius: '8px',
  boxShadow: 24,
  p: 4,
  maxHeight: '90vh',
  overflowY: 'auto',
};

function StudentDetails({ student, open, onClose }) {
  const [openImage, setOpenImage] = useState(false);

  if (!student) return null;

  const formatDate = (date) => {
    if (!date) return 'N/A';
    if (date instanceof Date) return date.toLocaleDateString('it-IT');
    if (date?.toDate) return date.toDate().toLocaleDateString('it-IT');
    if (typeof date === 'string') return new Date(date).toLocaleDateString('it-IT');
    return 'N/A';
  };

  const handleOpenImage = () => setOpenImage(true);
  const handleCloseImage = () => setOpenImage(false);

  return (
    <>
      <Modal open={open} onClose={onClose} aria-labelledby="student-details-modal">
        <Box sx={detailsModalStyle}>
          <Grid container spacing={2}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
              <Avatar
                src={student.photoURL || '/icons/default-avatar.png'}
                alt={`${student.nome} ${student.cognome}`}
                sx={{ width: 120, height: 120, cursor: 'pointer' }}
                onClick={handleOpenImage}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h5" className="student-name">
                {student.nome} {student.cognome}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="body1" className="student-detail">
                <strong>Data di Nascita:</strong> {formatDate(student.dataNascita)}
              </Typography>
              <Typography variant="body1" className="student-detail">
                <strong>Indirizzo:</strong> {student.indirizzo || 'N/A'}
              </Typography>
              <Typography variant="body1" className="student-detail">
                <strong>Presente:</strong> {student.present ? 'Sì' : 'No'}
              </Typography>
              <Typography variant="body1" className="student-detail">
                <strong>Consenso privacy:</strong> {student.privacyConsent ? 'Sì' : 'No'}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="body1" className="student-detail">
                <strong>Telefono Padre:</strong> {student.telefonoPadre || 'N/A'}
              </Typography>
              <Typography variant="body1" className="student-detail">
                <strong>Telefono Madre:</strong> {student.telefonoMadre || 'N/A'}
              </Typography>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="body1" className="student-detail">
                <strong>Note:</strong> {student.note || 'Nessuna nota'}
              </Typography>
            </Grid>

            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Button variant="contained" color="primary" onClick={onClose}>
                Chiudi
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      {/* Modal immagine ingrandita */}
      <Modal open={openImage} onClose={handleCloseImage} aria-labelledby="enlarged-image-modal">
        <Box sx={{ ...detailsModalStyle, maxWidth: 900 }}>
          <img
            src={student.photoURL || '/icons/default-avatar.png'}
            alt={`${student.nome} ${student.cognome}`}
            style={{ width: '100%', height: 'auto', display: 'block', borderRadius: 8 }}
          />
          <Box sx={{ textAlign: 'right', mt: 2 }}>
            <Button variant="contained" color="secondary" onClick={handleCloseImage}>
              Chiudi
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default StudentDetails;